import { formatMoney, toMoney } from '@betterment/core';
import { track } from '@betterment/js-runtime';
import { Box, DropdownMenu, IconButton, ListRow, Text } from '@betterment/samba-react';

import { TransitionaryGoal } from './data';

import { locationAssign } from '../../Shared/path-helpers';

const TransitionaryGoalRow: React.FC<React.PropsWithChildren<TransitionaryGoal>> = ({
  name,
  balanceCents,
  isPending,
  actionMenuItems,
}) => (
  <ListRow>
    <ListRow.LeadingContent>
      <Box as="span" css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 'space.50' }}>
        <Text>{name}</Text>
        {isPending && <Text color="text.weak">Pending</Text>}
      </Box>
      <Text variant="text50" color="text.weak">
        Individual taxable
      </Text>
    </ListRow.LeadingContent>
    <ListRow.TrailingContent>
      <Text>{formatMoney(toMoney(balanceCents))}</Text>
      <Text variant="text50" color="text.weak">
        Balance
      </Text>
    </ListRow.TrailingContent>
    <ListRow.TrailingAsset>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild={true}>
          <IconButton label="Show options" name="Ellipses" spacing="none" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="center" side="bottom">
          {actionMenuItems.map(item =>
            'path' in item && item.path ? (
              <DropdownMenu.Item
                key={item.title}
                onSelect={() => {
                  track('ElementClicked', item.trackingEventData);
                  locationAssign(item.path!);
                }}
              >
                {item.title}
              </DropdownMenu.Item>
            ) : null
          )}
        </DropdownMenu.Content>
      </DropdownMenu>
    </ListRow.TrailingAsset>
  </ListRow>
);

export default TransitionaryGoalRow;
